import { render, staticRenderFns } from "./NavigationLinkIconParts.vue?vue&type=template&id=21b35c3e"
import script from "./NavigationLinkIconParts.vue?vue&type=script&lang=ts"
export * from "./NavigationLinkIconParts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports